export default {
    "Administrator": {
        "id": "1",
        "level": "1",
        "name": "Administrator",
        "name_short": "A",
        "description": "With A privilege and can function as BM,SP, and W as well."
    },
    "Business Manager": {
        "id": "2",
        "level": "2",
        "name": "Business Manager",
        "name_short": "BM",
        "description": "With BM privilege and can function as SP and W as well."
    },
    "Sales Person": {
        "id": "3",
        "level": "3",
        "name": "Sales Person",
        "name_short": "SP",
        "description": "With SP privilege and can function as W as well."
    },
    "Worker": {
        "id": "4",
        "level": "4",
        "name": "Worker",
        "name_short": "W",
        "description": "With W privilege."
    },
    "Client": {
        "id": "5",
        "level": "5",
        "name": "Client",
        "name_short": "C",
        "description": "With C privilege. "
    },
    "Visitor": {
      "id": "6",
      "level": "6",
      "name": "Visitor",
    },
};



// WEBPACK FOOTER //
// ./src/config/permissionLevels.js